import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface ConfirmCancelDialogData {
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: 'primary' | 'accent' | 'warn';
  cancelColor?: 'primary' | 'accent' | 'warn';
}

@Component({
  selector: 'app-confirm-cancel-dialog',
  templateUrl: './confirm-cancel-dialog.component.html',
  styleUrls: ['./confirm-cancel-dialog.component.scss']
})
export class ConfirmCancelDialogComponent {
  data: ConfirmCancelDialogData;

  constructor(
    public dialogRef: MatDialogRef<ConfirmCancelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: ConfirmCancelDialogData,
    private translate: TranslateService
  ) {
    this.data = {
      confirmText: this.translate.instant('common_confirm'),
      cancelText: this.translate.instant('common_cancel'),
      confirmColor: 'warn',
      cancelColor: undefined,
      ...data
    };
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
